import axios from 'axios';
import {externalServices} from '../constants/resourceStrings.constants';

export const getRobloxUserId = async (token: string): Promise<string> => {
    const {userIdUrl} = externalServices.roblox;

    const result = await axios.get(userIdUrl, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });

    return result?.data?.sub;
};

export const getRobloxAuthToken = async (code: string): Promise<string> => {
    const {
        authUrl,
        redirectParams: {clientId},
        authParams: {clientSecret, grantType}
    } = externalServices.roblox;

    const config = {
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    };
    const payload = {
        client_id: clientId,
        client_secret: clientSecret,
        grant_type: grantType,
        code
    };

    const tokenResult = await axios.post(authUrl, payload, config);
    const userId = await getRobloxUserId(tokenResult?.data?.access_token);

    return userId;
};
